/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Julia Ignatieva
 * @version 1.16.0
 * @since 1.16.0
 */

import { createAction } from '../../modules/app/createAction';
import {
    IWizardImportPersonalDataAttachFileActionPayload,
    IWizardImportPersonalDataAttachFileSuccessfulActionPayload,
    IWizardImportPersonalDataSetStepValidPayload,
    TWizardImportPersonalDataAttachFile,
    TWizardImportPersonalDataAttachFileFailedAction,
    TWizardImportPersonalDataAttachFileSuccessfulAction,
    TWizardImportPersonalDataHandleNextAction,
    TWizardImportPersonalDataInitValidatedList,
    TWizardImportPersonalDataInitValidatedListFailedAction,
    TWizardImportPersonalDataSetParamsAction,
    TWizardImportPersonalDataSetParamsPayload,
    TWizardImportPersonalDataSetStepValidAction,
    TWizardImportPersonalDataStartValidateAction,
} from './types/wizardImportPersonalDataActionTypes';
import {
    WIZARD_IMPORT_PERSONAL_DATA_ATTACH_FILE,
    WIZARD_IMPORT_PERSONAL_DATA_ATTACH_FILE_FAILED,
    WIZARD_IMPORT_PERSONAL_DATA_ATTACH_FILE_SUCCESSFUL,
    WIZARD_IMPORT_PERSONAL_DATA_HANDLE_NEXT,
    WIZARD_IMPORT_PERSONAL_DATA_INIT_VALIDATED_LIST,
    WIZARD_IMPORT_PERSONAL_DATA_INIT_VALIDATED_LIST_FAILED,
    WIZARD_IMPORT_PERSONAL_DATA_SET_PARAMS,
    WIZARD_IMPORT_PERSONAL_DATA_SET_STEP_VALID,
    WIZARD_IMPORT_PERSONAL_DATA_START_VALIDATE,
} from './wizardImportPersonalDataConstant';

/*
* -------------------------------------------
*         Common Wizard Actions
* -------------------------------------------
*/

export const wizardImportPersonalDataHandleNextAction = (): TWizardImportPersonalDataHandleNextAction =>
    createAction(WIZARD_IMPORT_PERSONAL_DATA_HANDLE_NEXT);

export const wizardImportPersonalDataSetParamsAction = (payload: TWizardImportPersonalDataSetParamsPayload)
    : TWizardImportPersonalDataSetParamsAction =>
    createAction(WIZARD_IMPORT_PERSONAL_DATA_SET_PARAMS, payload);

export const wizardImportPersonalDataStartValidateAction = ():
    TWizardImportPersonalDataStartValidateAction => createAction(WIZARD_IMPORT_PERSONAL_DATA_START_VALIDATE);

export const wizardImportPersonalDataSetStepValidAction = (payload: IWizardImportPersonalDataSetStepValidPayload):
    TWizardImportPersonalDataSetStepValidAction => createAction(WIZARD_IMPORT_PERSONAL_DATA_SET_STEP_VALID, payload);

/*
* -------------------------------------------
*          ATTACH FILE
* -------------------------------------------
*/

export const wizardImportPersonalDataAttachFile = (payload: IWizardImportPersonalDataAttachFileActionPayload):
    TWizardImportPersonalDataAttachFile => createAction(WIZARD_IMPORT_PERSONAL_DATA_ATTACH_FILE, payload);

export const wizardImportPersonalDataAttachFileSuccessful =
    (payload: IWizardImportPersonalDataAttachFileSuccessfulActionPayload):
        TWizardImportPersonalDataAttachFileSuccessfulAction =>
        createAction(WIZARD_IMPORT_PERSONAL_DATA_ATTACH_FILE_SUCCESSFUL, payload);

export const wizardImportPersonalDataAttachFileFailed =
    (payload: string): TWizardImportPersonalDataAttachFileFailedAction =>
        createAction(WIZARD_IMPORT_PERSONAL_DATA_ATTACH_FILE_FAILED, payload);

/*
* -------------------------------------------
*          LOAD TABLE DATA
* -------------------------------------------
*/

export const wizardImportPersonalDataInitValidatedList = (): TWizardImportPersonalDataInitValidatedList =>
    createAction(WIZARD_IMPORT_PERSONAL_DATA_INIT_VALIDATED_LIST);

export const wizardImportPersonalDataInitValidatedListFailed =
    (payload: string): TWizardImportPersonalDataInitValidatedListFailedAction =>
        createAction(WIZARD_IMPORT_PERSONAL_DATA_INIT_VALIDATED_LIST_FAILED, payload);
